import {AppUrls} from 'shared/config/model/urls';

import {useEffect} from 'react';
import {useNavigate, useParams} from 'react-router-dom';

import {clearStoredAuthTokens, getConfirmDeletionUrl} from '../lib/accountLinks';

export const useConfirmDeletion = () => {
    const {token} = useParams<{token: string}>();
    const navigate = useNavigate();

    useEffect(() => {
        if (!token) return;

        fetch(getConfirmDeletionUrl(token), {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({}),
            credentials: 'omit',
        })
            .then(clearStoredAuthTokens);
    }, [token]);

    return {handleContinue: () => navigate(AppUrls.LOGIN)};
};

export default useConfirmDeletion;
